module.exports = __webpack_public_path__ + "img/BETSY_VideoLoading_1.8a340d5f.png";